/** Icon paths carried over from the design artboard. */
const PATHS: Record<string, string[]> = {
  mdm: ['M3 21h18', 'M5 21V8l7-4 7 4v13', 'M9.5 21v-6h5v6'],
  inv: ['M3 7.5 12 3l9 4.5v9L12 21 3 16.5z', 'M3 7.5 12 12l9-4.5', 'M12 12v9'],
  ops: ['M7 3h10v18H7z', 'M10 7h4', 'M10 11h4', 'M10 15h4'],
  sd: [
    'M2 16V7h11v9',
    'M13 10h4l4 4v2h-8',
    'M6.5 19a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6',
    'M17.5 19a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6',
  ],
  fin: ['M4 4h16v16H4z', 'M8 4v16', 'M12 9h5', 'M12 13h5'],
  hr: [
    'M9 11a3.4 3.4 0 1 0 0-6.8A3.4 3.4 0 0 0 9 11',
    'M2.5 20c0-3.6 2.9-5.6 6.5-5.6s6.5 2 6.5 5.6',
    'M16 4.6a3.2 3.2 0 0 1 0 6.2',
    'M18 14.8c2.1.6 3.5 2.3 3.5 5.2',
  ],
  rep: ['M4 20h16', 'M7 20V11', 'M12 20V5', 'M17 20v-7'],
  iam: ['M12 3l7 3v6c0 4.2-2.9 7.6-7 9-4.1-1.4-7-4.8-7-9V6z', 'M9.3 12.2l2 2 3.6-3.9'],
};

export function ModuleIcon({ id, active }: { id: string; active: boolean }) {
  const paths = PATHS[id] ?? PATHS.inv!;

  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 24 24"
      fill="none"
      stroke={active ? '#ffffff' : '#9a9e99'}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      style={{ display: 'block', flex: '0 0 auto' }}
    >
      {paths.map((d, i) => (
        <path key={i} d={d} />
      ))}
    </svg>
  );
}

/** The topbar's calendar shortcut. */
export function CalendarIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      style={{ display: 'block', flex: '0 0 auto' }}
    >
      <path d="M4 5.5h16v15H4z" />
      <path d="M4 9.5h16" />
      <path d="M8 3v4" />
      <path d="M16 3v4" />
    </svg>
  );
}

/** The settings cog, from the design artboard. */
export function SettingsIcon({ active }: { active: boolean }) {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 24 24"
      fill="none"
      stroke={active ? '#ffffff' : '#9a9e99'}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      style={{ display: 'block', flex: '0 0 auto' }}
    >
      <path d="M12 15.2a3.2 3.2 0 1 0 0-6.4 3.2 3.2 0 0 0 0 6.4" />
      <path d="M19.6 14.4a7.7 7.7 0 0 0 0-4.8l1.9-1.3-1.9-3.3-2.2.8a7.7 7.7 0 0 0-4.1-2.4L13 1h-2l-.3 2.4a7.7 7.7 0 0 0-4.1 2.4l-2.2-.8L2.5 8.3l1.9 1.3a7.7 7.7 0 0 0 0 4.8l-1.9 1.3 1.9 3.3 2.2-.8a7.7 7.7 0 0 0 4.1 2.4L11 23h2l.3-2.4a7.7 7.7 0 0 0 4.1-2.4l2.2.8 1.9-3.3z" />
    </svg>
  );
}
